import type { MapPageDom } from './types';

/**
 * Shows the map-level error block with a specific user-facing message.
 *
 * @param params Page DOM and the user-facing map-load failure text.
 * @returns Nothing. Reveals the blocking map error block.
 */
export function renderMapError(params: { mapDom: MapPageDom; message: string }): void {
  params.mapDom.errorMessage.textContent = params.message;
  params.mapDom.error.classList.remove('hidden');
}

/**
 * Hides the map-level error block when the API call succeeds again.
 *
 * @param params Page DOM for the `/map` screen.
 * @returns Nothing. Hides the blocking map error block without changing its cached message.
 */
export function hideMapError(params: { mapDom: MapPageDom }): void {
  params.mapDom.error.classList.add('hidden');
}

/**
 * Renders a non-blocking fallback text for the total debt block.
 *
 * @param params Page DOM for the debt summary block.
 * @returns Nothing. Replaces the summary with a non-blocking fallback message.
 */
export function renderTotalDebtError(params: { mapDom: MapPageDom }): void {
  params.mapDom.totalDebtText.textContent = 'Не удалось загрузить';
}
